var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('H3',[_vm._v("Hola, Earn & Credit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }